import { lazy }  from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux'
import { useCheckAccess } from "./hooks/useCheckAccess";
import { store } from './store.js'
import Loadable from "./General/Loadable.jsx";
import { setEntry } from "./EntryHelpers/setEntry.js";
import { useRootCssVars } from "./hooks/useRootCssVars.js";

const PageFrontOverview = Loadable(lazy(() => import("./PageFrontOverview/index.jsx")))

const AccessWrapperOverviewWithSlider = ({isWebApp}) => {
    const useAccesTheme = useCheckAccess() 
    useRootCssVars(useAccesTheme)

    if(useAccesTheme) {
        const PageOverviewAccess = Loadable(lazy(() => import( "./PageOverviewAccess/PageOverviewAccess.jsx" )))

        return <PageOverviewAccess withMainSlider={true} /> 
    } else {
        return <PageFrontOverview isOverviewPage={true} isWebApp={isWebApp}/>
    }
}

const elem = document.querySelector("#overview-page-with-slider")

if(elem)  {
    const [isWebApp, isMobile] = setEntry()

    ReactDOM.render(
        <Provider store={store}>
            <AccessWrapperOverviewWithSlider isWebApp={isWebApp}/>
        </Provider>
    , elem)
}
